import React from 'react'
import CallbackImage from '../../../assets/images/request-callback.webp'
import Button from '../../atoms/GoodFlipButton'
import Text from '../../atoms/Text'
import { useSelector } from 'react-redux'
import { requestCallback } from '../../../api'

const RequestCallback = ({ onSuccess = () => {} }) => {
  const { userDetails } = useSelector((s) => s.auth)
  const onClick = async () => {
    try {
      const payload = {
        name: userDetails?.data?.name,
        email: userDetails?.data?.email,
        phone_number: userDetails?.data?.contact_no,
        campaign_type: 'CKD PSP',
      }

      await requestCallback(payload)
      onSuccess()
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:gap-10 lg:px-4">
      <div className="px-4 lg:px-0 flex flex-col gap-2 lg:flex-1">
        <Text
          tag={'p'}
          variant={'headline'}
          size={'large'}
          className={'text-text-primary'}
        >
          Have questions? Get answers from our health experts
        </Text>
        <Text
          tag={'p'}
          variant={'body'}
          size={'medium'}
          className={'text-text-quartenary'}
        >
          Our team of specialists is here to help you make the best decisions
          for your kidney health
        </Text>
        <div className="hidden lg:block lg:mt-2">
          <Button
            title={'Request Callback'}
            type={'goodflip_secondary'}
            onClick={onClick}
            className="!mx-0 lg:!max-w-xs"
            leftIcon={null}
            rightIcon={null}
          />
        </div>
      </div>
      <div className="lg:flex-1 lg:max-w-sm">
        <img
          src={CallbackImage}
          alt="callback"
          className="w-full h-auto lg:rounded-xl"
        />
      </div>
      <div className="lg:hidden">
        <Button
          title={'Request Callback'}
          type={'goodflip_secondary'}
          onClick={onClick}
          className="!mx-4"
          leftIcon={null}
          rightIcon={null}
        />
      </div>
    </div>
  )
}

export default RequestCallback
